export default __webpack_public_path__ + "assets/b6389e.svg";